// static/script/Manager/HawkUtils.js

class HawkUtils {
    constructor() {
    }

    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // -------------------------------------------------------
    // 0. CANVAS / GÖRSEL YARDIMCILARI
    // -------------------------------------------------------

    // iOS Safari toplam canvas belleğini sınırlar ve kullanılmayan canvas'ları
    // hemen boşaltmaz. Boyutu sıfırlamak arka tamponu anında serbest bırakır.
    releaseCanvas(canvas) {
        if (!canvas) return;
        canvas.width = 0;
        canvas.height = 0;
    }

    // Dosyayı FileReader ile base64'e çevirmek yerine object URL üzerinden
    // yükler: 10 MB'lık bir dosya için ~13 MB'lık dizge yerine sadece referans.
    loadImage(src) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error('Görsel çözümlenemedi'));
            img.src = src;
        });
    }

    // -------------------------------------------------------
    // 1. AKILLI RESİM İŞLEME (Görünen Pikselleri Kırpma & Ölçekleme)
    // -------------------------------------------------------

    async processImage(file, activeIndex, categoryInput) {
        const objectUrl = URL.createObjectURL(file);
        let img;

        try {
            img = await this.loadImage(objectUrl);
        } catch (error) {
            console.error('[HawkUtils] Görsel okunamadı:', error);
            alert('Görsel okunamadı. Lütfen PNG veya JPG bir dosya deneyin.');
            return null;
        } finally {
            // Görsel çözümlendikten sonra URL'e ihtiyaç yok.
            URL.revokeObjectURL(objectUrl);
        }

        if (img.width < 300 || img.width > 4097 || img.height < 300 || img.height > 4097) {
            alert('Lütfen 300px ile 4096px arasında bir resim yükleyin.');
            return null;
        }

        // Kategoriyi güvenli hale getir (küçük harf)
        const category = categoryInput.toLowerCase();

        // Ürün ismini al
        const productTitle = (window.tasarimismiKontrol && window.tasarimismiKontrol[0]) ? window.tasarimismiKontrol[0] : "";

        // Varsayılanlar
        let scaleX = 0.5;
        let scaleY = 0.5;
        let targetW = 2048;
        let targetH = 2048;

                    // --- ÖZEL DURUMLAR ---

        // 1. FAB BEL YASTIK (Stretch Fix)
        if (category === "aksesuar" && productTitle.includes("Fab Bel") && activeIndex === 3) {
            scaleX = 0.5;
            scaleY = 1.0; // Dikeyde tam boy (Eski kodun mantığı)
        }

        // 2. FUTURE BEL YASTIK
        else if (category === "aksesuar" && productTitle.includes("Future Bel") && activeIndex === 3) {
            scaleX = 0.5;
            scaleY = 0.5;
        }

        // 3. BAŞ YASTIKLARI (Aksesuar)
        else if (category === "aksesuar" && (productTitle.includes("Baş") || productTitle.includes("Bas")) && activeIndex === 5) {
            scaleX = 0.5;
            scaleY = 0.5;
        }

        // 4. STANDART KOLTUKLAR
        else if (activeIndex === 1) { // ÖN
            scaleX = 0.5; scaleY = 0.5;
        }
        else if (activeIndex === 2) { // ARKA
            scaleX = 0.65; scaleY = 0.65;
        }
        else if (activeIndex === 3) { // BEL
            // Koltuk üzerindeki Fab Bel Yastığı
            if (category.includes("fab")) {
                scaleX = 0.5; scaleY = 1.0;
            } else {
                scaleX = 0.5; scaleY = 0.5;
            }
        }
        else if (activeIndex === 5) { // YASTIK / NICKNAME
            if (category.includes("pro")) {
                scaleX = 0.8; scaleY = 0.8; targetH = 1024;
            }
            else if (category.includes("fab")) {
                scaleX = 0.3; scaleY = 0.3;
            }
            else {
                scaleX = 0.5; scaleY = 0.5;
            }
        }

        console.log(`📏 Resize: ${scaleX}x${scaleY} (Kat: ${category}, Ürün: ${productTitle})`);

        return await this.resizeBasedOnVisiblePixels(img, targetW, targetH, scaleX, scaleY);
    }

    // Saydam kenarları kırpar, görseli hedef canvas'ın ortasına ölçekleyerek çizer.
    // Çıktı biçimi PNG data URL — sunucuya giden baytlar değişmedi.
    async resizeBasedOnVisiblePixels(image, targetWidth, targetHeight, scaleRatioX, scaleRatioY) {
        // 1. Dolu alanın sınırlarını bul (küçültülmüş kopyada — aşağıya bak)
        const box = this.findVisibleBounds(image);
        const visibleWidth = box.width;
        const visibleHeight = box.height;

        // --- 2. PADDING (BOŞLUK) AYARI ---
        // Kenarlardan kesilmeyi önlemek için güvenli alan oluşturuyoruz.
        // 2048px'lik alanda 150px boşluk bırakırsak resim taşmaz.
        const padding = 150;

        const safeTargetWidth = targetWidth - (padding * 2);
        const safeTargetHeight = targetHeight - (padding * 2);

        // 3. Oranlama (Güvenli alana göre)
        const ratio = Math.min(safeTargetWidth / visibleWidth, safeTargetHeight / visibleHeight);

        const newWidth = visibleWidth * ratio * scaleRatioX;
        const newHeight = visibleHeight * ratio * scaleRatioY;

        // 4. Final Canvas
        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = targetWidth;
        finalCanvas.height = targetHeight;
        const finalCtx = finalCanvas.getContext('2d');

        // 5. ÇİZİM (CROP & CENTER)
        // Kaynak resimden sadece dolu alanı kesip alıyoruz,
        // hedef canvas'ın tam ortasına paddingli boyutta çiziyoruz.
        finalCtx.drawImage(
            image,
            box.x, box.y, visibleWidth, visibleHeight, // Kaynak koordinatları (Crop)
            (targetWidth - newWidth) / 2,              // Hedef X (Ortala)
            (targetHeight - newHeight) / 2,            // Hedef Y (Ortala)
            newWidth, newHeight                        // Hedef Boyut
        );

        const dataUrl = finalCanvas.toDataURL('image/png');
        this.releaseCanvas(finalCanvas);
        return dataUrl;
    }

    // Saydam olmayan piksellerin sınır kutusunu bulur.
    //
    // Analiz, görselin en fazla 512px'e küçültülmüş bir kopyasında yapılır.
    // Sebep: 4096x4096 bir yüklemede tam boyut analiz ~67 MB canvas + ~67 MB
    // piksel dizisi ayırıyor ve 16,7 milyon yinelemeli bir döngü ana iş
    // parçacığını saniyelerce kilitliyordu — iOS Safari sekmeyi bu yüzden
    // öldürüyordu. Küçültülmüş kopyada aynı iş ~1 MB ve 262 bin yineleme.
    //
    // Bulunan kutu orijinal ölçeğe geri çevrilir; 1 analiz pikseli güvenlik
    // payı eklenir, böylece kırpma asla eskisinden dar olmaz.
    findVisibleBounds(image) {
        const MAX_ANALYSIS_SIZE = 512;
        const scale = Math.min(1, MAX_ANALYSIS_SIZE / Math.max(image.width, image.height));
        const w = Math.max(1, Math.round(image.width * scale));
        const h = Math.max(1, Math.round(image.height * scale));

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(image, 0, 0, w, h);

        let minX = w, minY = h, maxX = -1, maxY = -1;

        try {
            const pixels = ctx.getImageData(0, 0, w, h).data;
            for (let y = 0; y < h; y++) {
                const rowStart = y * w;
                for (let x = 0; x < w; x++) {
                    if (pixels[(rowStart + x) * 4 + 3] > 0) {
                        if (x < minX) minX = x;
                        if (x > maxX) maxX = x;
                        if (y < minY) minY = y;
                        if (y > maxY) maxY = y;
                    }
                }
            }
        } catch (error) {
            // getImageData bellek ya da güvenlik nedeniyle patlarsa tüm görseli kullan
            console.warn('[HawkUtils] Sınır analizi yapılamadı, tam görsel kullanılıyor:', error);
            maxX = -1;
        } finally {
            this.releaseCanvas(canvas);
        }

        // Tamamen saydam ya da analiz başarısız: tüm görseli kullan
        if (maxX < minX || maxY < minY) {
            return { x: 0, y: 0, width: image.width, height: image.height };
        }

        const inverse = 1 / scale;
        const x = Math.max(0, Math.floor((minX - 1) * inverse));
        const y = Math.max(0, Math.floor((minY - 1) * inverse));
        const right = Math.min(image.width, Math.ceil((maxX + 2) * inverse));
        const bottom = Math.min(image.height, Math.ceil((maxY + 2) * inverse));

        return {
            x,
            y,
            width: Math.max(1, right - x),
            height: Math.max(1, bottom - y)
        };
    }
    // HawkUtils.js içine ekle:

    // Base64 -> Blob Dönüştürücü
    base64ToBlob(base64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(base64Data.split(',')[1]);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) { byteNumbers[i] = slice.charCodeAt(i); }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    // Aspect Ratio Korumalı Resize
    // HawkUtils.js -> resizeImageToBlobWithAspectRatio (GARANTİLİ PROMISE)

    // HawkUtils.js -> resizeImageToBlobWithAspectRatio (GARANTİ PROMISE)

    // HawkUtils.js -> resizeImageToBlobWithAspectRatio

    async resizeImageToBlobWithAspectRatio(dataUrl, targetWidth, targetHeight, contentType = 'image/webp', quality = 0.8) {
        
        // Promise Timeout Wrapper (3 Saniye Kuralı)
        const processPromise = new Promise((resolve) => {
            if (!dataUrl || dataUrl.length < 100) {
                console.error("   [HawkUtils] HATA: Geçersiz DataURL!");
                resolve(null);
                return;
            }

            const img = new Image();
            img.crossOrigin = "Anonymous"; // Güvenlik kilidini açmayı dene

            img.onload = () => {
                try {
                    const canvas = document.createElement('canvas');
                    const scale = Math.min(targetWidth / img.width, targetHeight / img.height);
                    
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    canvas.toBlob((blob) => {
                        this.releaseCanvas(canvas);
                        resolve(blob || null);
                    }, contentType, quality);

                } catch (e) {
                    console.error("   [HawkUtils] Try-Catch Hatası:", e);
                    resolve(null);
                }
            };

            img.onerror = (err) => {
                console.error("   [HawkUtils] Image Load Hatası:", err);
                resolve(null);
            };

            img.src = dataUrl;
        });

        // 3 Saniyelik Zaman Aşımı Yarışı
        const timeoutPromise = new Promise((resolve) => {
            setTimeout(() => {
                console.warn("   [HawkUtils] ⚠️ Zaman aşımı! İşlem çok uzun sürdü.");
                resolve(null);
            }, 3000);
        });

        // Hangisi önce biterse onu döndür
        return Promise.race([processPromise, timeoutPromise]);
    }
    // -------------------------------------------------------
    // 2. NICKNAME ÇİZİMİ (FONT BÜYÜTME & RENK)
    // -------------------------------------------------------
    async drawTextToCanvas(text, color, fontType) {
        // Fontu yüklemeyi dene
        try { await document.fonts.load("160px Anton"); } catch(e){}

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Canvas boyutu (Yüksek kalite için büyük tutuyoruz)
        canvas.width = 2048; 
        canvas.height = 1024; 

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        const typeLower = (fontType || "future").toLowerCase();

        // Pro serisi için dikey esnetme (Stretch)
        if (typeLower.includes("pro")) {
            ctx.scale(1, 1.5); 
        }

        // FONT BOYUTU: 4 Kat Büyütüldü (Eskiden 42px idi, şimdi 160px civarı)
        // Fab için biraz daha küçük, diğerleri için büyük
        const fontSize = typeLower.includes("fab") ? "160px" : "240px";
        
        ctx.font = `${fontSize} "Anton", sans-serif`;
        ctx.fillStyle = color;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        // Canvas merkezini bul (Scale varsa ona göre ayarla)
        const centerX = canvas.width / 2;
        const centerY = (canvas.height / 2) / (typeLower.includes("pro") ? 1.5 : 1);

        ctx.fillText(text, centerX, centerY);

        // Blob oluştur ve MaterialManager'a gönder
        canvas.toBlob(async (blob) => {
            this.releaseCanvas(canvas);
            if (!blob) return;

            const url = URL.createObjectURL(blob);
            try {
                if (window.hawkMaterials) {
                    // applyTexture -> viewer.createTexture(url) tamamlanana kadar bekler,
                    // dolayısıyla bu await bittiğinde doku hazır ve URL'e ihtiyaç kalmaz.
                    await window.hawkMaterials.applyNicknameTexture(url);
                }
            } finally {
                // Bu revoke olmadan her nakış yazısı kalıcı bir blob sızdırıyordu.
                URL.revokeObjectURL(url);
            }
        }, "image/webp");
    }

    // -------------------------------------------------------
    // 3. URL İLE TASARIM AÇMA (paylaşım linkleri)
    //    Biçim: ?klasor/urunAdi/desenAdi
    //    Örn:   ?future/coal/kirmizi-desen
    // -------------------------------------------------------
    parseURLParams() {
        try {
            const raw = decodeURIComponent(window.location.search.slice(1));
            if (!raw) return null;

            const parts = raw.toLowerCase().split('/');
            if (parts.length === 0) return null;

            return {
                klasor: parts[0] || null,
                productTitle: parts[1] || null,
                patternTitle: parts[2] || null
            };
        } catch (error) {
            console.error("URL parse hatası:", error);
            return null;
        }
    }

    // Ekrandaki yükleme göstergeleri kapanana kadar bekler (en fazla 30 sn).
    waitForLoader() {
        return new Promise((resolve) => {
            const timeout = setTimeout(() => {
                clearInterval(interval);
                resolve();
            }, 30000);

            const interval = setInterval(() => {
                const midLoader = document.getElementById("midLoader");
                const sonLoader = document.getElementById("loadingson");

                const midHidden = !midLoader
                    || midLoader.style.display === 'none'
                    || getComputedStyle(midLoader).display === 'none';
                const sonHidden = !sonLoader
                    || sonLoader.style.display === 'none'
                    || getComputedStyle(sonLoader).display === 'none';

                if (midHidden && sonHidden) {
                    clearInterval(interval);
                    clearTimeout(timeout);
                    resolve();
                }
            }, 500);
        });
    }

    // Boşlukları ve büyük/küçük harfi yok sayarak ürün başlığından id bulur.
    findProductIdByTitle(items, title) {
        if (!items || !title) return null;
        const needle = title.replace(/\s/g, '').toLowerCase();
        return items.find(item =>
            item.Title.toLowerCase().replace(/\s/g, '').includes(needle)
        )?.id || null;
    }

    findPatternIdByTitle(patterns, title) {
        if (!patterns || !title) return null;
        const needle = title.replace(/\s/g, '').toLowerCase();
        return patterns.find(pattern =>
            pattern.Title.toLowerCase().replace(/\s/g, '').includes(needle)
        )?.PatternID || null;
    }

    // URL'deki kategori / ürün / desen bilgisini sırayla tıklayarak uygular.
    // catalog = window.hawk_data2 ({ items: [...] })
    async applyFromURL(catalog) {
        const params = this.parseURLParams();
        if (!params || !params.klasor) return;

        console.log("🔗 URL Modu Başlatıldı:", params);
        window.isAutoURLSelection = true;

        const tabButtons = {
            fab: 'fabklasor',
            future: 'futureklasor',
            pro: 'proklasor',
            fame: 'fameklasor',
            aksesuar: 'aksesuarklasor'
        };

        const tabButton = document.getElementById(tabButtons[params.klasor]);
        if (tabButton) tabButton.click();
        await new Promise(resolve => setTimeout(resolve, 200));

        let items;
        if (params.klasor === "aksesuar") {
            items = catalog.items.filter(item => item.Category === "Aksesuar");
        } else {
            const category = params.klasor.charAt(0).toUpperCase() + params.klasor.slice(1);
            items = catalog.items.filter(item => item.Category === category);
        }

        if (!items || items.length === 0) {
            window.isAutoURLSelection = false;
            return;
        }

        if (params.productTitle) {
            const productId = this.findProductIdByTitle(items, params.productTitle);
            if (productId) {
                const productCard = document.querySelector(`.hawkchair[id="${productId}"]`);
                if (productCard) {
                    console.log('💺 URL Ürün: ' + productId);
                    productCard.click();

                    console.log("⏳ Model bekleniyor...");
                    await this.waitForLoader();

                    if (params.patternTitle) {
                        const product = items.find(item => item.id === productId);
                        const patterns = product?.Patterns || [];
                        const patternId = this.findPatternIdByTitle(patterns, params.patternTitle);

                        if (patternId) {
                            const patternEl = document.querySelector(`.pattern-content[data-pattern-id="${patternId}"]`);
                            if (patternEl) {
                                console.log("🎨 URL Desen: " + patternId);
                                patternEl.click();
                            }
                        }
                    }
                }
            }
        }

        console.log("✅ URL İşlemi Tamam.");
        window.isAutoURLSelection = false;
    }
}

window.hawkUtils = new HawkUtils();